import { LogLevel, getLogger } from '@ori/checkout-utils';
import { Suspense, useContext } from 'react';

import { WizardLoader } from '../components';
import { APP_NAME } from '../constants';
import { wizardContext } from '../contexts';
import { SubscriptionContainer } from './SubscriptionContainer';

const logDebug = getLogger(APP_NAME, LogLevel.Debug);

export const SubscriptionTypesContainer = () => {
  const { wizardType, productCode, id, open } = useContext(wizardContext);
  logDebug(
    'SubscriptionTypesContainer type: ',
    wizardType,
    ' | open: ',
    open,
    ' | product: ',
    productCode,
    ' | id: ',
    id,
  );

  if (!wizardType) {
    logDebug('SubscriptionTypesContainer return null');

    return null;
  }

  return (
    <Suspense fallback={<WizardLoader />}>
      <SubscriptionContainer
        key={id}
        product={productCode}
      />
    </Suspense>
  );
};
